export const dataHooks = {
  input: 'file-upload-input',
};
